<aw-general-item-detail-dialog fxFlexAlign="stretch" [inputData]="dataSource"></aw-general-item-detail-dialog>